import { useExtendedWarrantyContext } from '@extendedWarranty/contexts/ExtendedWarrantyContext';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { FormControl, FormControlLabel, Switch, TextField, Tooltip, Typography } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers-pro';
import { addDays, format } from 'date-fns';

const CommonEWFormFields = () => {
    const {
        lockNameField,
        lockDateField,
        formik: { values, setFieldValue, errors, touched, handleBlur, handleChange },
    } = useExtendedWarrantyContext();

    return (
        <>
            <div className="flex flex-col md:flex-row gap-8 md:gap-14">
                <FormControl className="flex-grow">
                    <Typography className="mb-2" color="black" fontWeight={700} variant="body2">
                        Installation name
                    </Typography>
                    <TextField
                        disabled={lockNameField}
                        id="installation_name"
                        name="installation_name"
                        placeholder="My Installation 1"
                        value={values.installation_name}
                        onChange={(e) => setFieldValue('installation_name', e.target.value)}
                        onBlur={handleBlur}
                        error={touched.installation_name && Boolean(errors.installation_name)}
                        helperText={touched.installation_name && errors.installation_name}
                    />
                </FormControl>
                <FormControl className="flex-grow">
                    <Typography className="mb-2" color="black" fontWeight={700} variant="body2">
                        Installation date
                    </Typography>
                    <DatePicker
                        format="yyyy-MM-dd"
                        value={values.date_installed ? new Date(values.date_installed) : null}
                        onChange={(value) => setFieldValue('date_installed', value, true)}
                        maxDate={addDays(new Date(), 7)}
                        slotProps={{
                            textField: {
                                error: touched.date_installed && Boolean(errors.date_installed),
                                helperText: touched.date_installed && errors.date_installed,
                                id: 'date_installed',
                                name: 'date_installed',
                                placeholder: format(new Date(), 'yyyy-MM-dd'),
                                disabled: lockDateField,
                                onBlur: handleBlur,
                            },
                        }}
                    />
                </FormControl>
            </div>
            <div className="flex gap-6">
                <Tooltip
                    placement="top"
                    title="Please indicate if support request received by Victron should be directed to you directly instead of the Victron Distributor"
                >
                    <div className="bg-alert-info-bg w-fit flex gap-3 px-4 py-3 rounded-md">
                        <InfoOutlinedIcon className="text-blue-cola" />
                        <Typography className="text-ateneo-blue" fontWeight={500}>
                            Will Provide Support
                        </Typography>
                    </div>
                </Tooltip>
                <FormControlLabel
                    control={<Switch size="medium" name="support" checked={values?.support} onChange={handleChange} />}
                    label=""
                />
            </div>
        </>
    );
};

export { CommonEWFormFields };
